<template>
<div>
  
  <div class="refereebox" v-if="match.referee">Arbitre : {{match.referee.name}}</div>
  <div class="matchbox" v-on:click="fillScore(match)">
    <div class="teambox" :style="'background-color: ' + leftTeam.color">
      <p class="teamid"></p>
    </div>
    <div>
      <div style="margin-bottom:10px;">
        <div class="scorebox" v-if="match.score">{{match.score.leftScore}} - {{match.score.rightScore}}</div>
        <div class="scorebox" v-else>VS</div>
      </div>
      <div class="player-grid">
        <div class="playerbox-left">
          <p v-for="player in match.leftPlayers" v-bind:key="player.id">{{player.firstname}} &nbsp; {{player.name}}</p>
        </div>
        <div class="playerbox-right">
          <p v-for="player in match.rightPlayers" v-bind:key="player.id">{{player.firstname}} &nbsp; {{player.name}}</p>
        </div>
      </div>
    </div>
    <div class="teambox" :style="'background-color: ' + rightTeam.color">
      <p class="teamid"></p>
    </div>
  </div>
</div>
</template>

<script>
export default {  
  name: "Match",
  props: {
    match: Object
  },
  computed: {
    leftTeam: function() {
      return this.$store.state.teams.find(team => team.id === this.match.leftTeam);
    },
    rightTeam: function() {
      return this.$store.state.teams.find(team => team.id === this.match.rightTeam);
    }
  },
  methods: {
    fillScore: function(match){
      this.$router.push({ path: '/score/' + match.id })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.matchbox{
  background-color: #f1f1f1;
  border-radius: 5px;
  /*box-shadow: 1px 1px 4px #555;*/
  box-shadow: 0.1em 0.3em 0.4em #bbb;
  height: 100px;
  width: 100%;
  margin-bottom:20px;
  position:relative;
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
}
.teambox{
  height: 100px;
  border-radius: 5px;
  text-align: center;
}
.teamid{
  width: 100%;
  color: #404040;
  font-size: 2em;
  margin: 0px;
  line-height: 100px;
}
.scorebox{
  background-color: #404040;
  width: 100px;
  margin: auto;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  color: whitesmoke;
  font-weight: bold;
  text-align: center;
}
.player-grid{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.player-grid p{
  margin: 0px;
}
.playerbox-left{
  border-right: 1px solid #2b2b2b;
  color: #404040;
  font-weight: bold;
  text-align: center;
}
.playerbox-right{
  color: #404040;
  font-weight: bold;
  text-align: center;
}
.refereebox{
  background-color: #c3c3c3;
  color: #404040;
  font-weight: bold;
  text-align: center;
  box-shadow: 0.1em 0.3em 0.4em #bbb;
  border-radius: 5px;
  width: 300px;
  margin: auto;
  margin-bottom: 0px;
  position: relative;
  padding-bottom: 10px;
  top : 10px;
}
</style>
